import api from "../../services/api";

/**
 * Interview Feedback (scorecards) API for a recruiter Candidate.
 * All endpoints live under /api and require auth:sanctum + tenant_token + role:hr_admin|recruiter.
 */

/**
 * List all interview scorecards for a candidate plus an aggregate summary.
 * @param {number|string} candidateId
 * @returns {Promise<{ data: Array, summary: { count:number, average_rating:number|null, recommendation_counts: Object } }>}
 */
export async function listInterviews(candidateId) {
  const res = await api.get(`/recruiter/candidates/${candidateId}/interviews`);
  return res.data;
}

/**
 * Create a new interview scorecard for a candidate.
 * @param {number|string} candidateId
 * @param {Object} payload
 * @returns {Promise<{ message:string, data:Object }>}
 */
export async function createInterview(candidateId, payload) {
  const res = await api.post(`/recruiter/candidates/${candidateId}/interviews`, payload);
  return res.data;
}

/**
 * Update an existing interview scorecard.
 * @param {number|string} interviewId
 * @param {Object} payload
 * @returns {Promise<{ message:string, data:Object }>}
 */
export async function updateInterview(interviewId, payload) {
  const res = await api.put(`/recruiter/candidate-interviews/${interviewId}`, payload);
  return res.data;
}

/**
 * Delete an interview scorecard.
 * @param {number|string} interviewId
 * @returns {Promise<{ message:string }>}
 */
export async function deleteInterview(interviewId) {
  const res = await api.delete(`/recruiter/candidate-interviews/${interviewId}`);
  return res.data;
}
